import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

/**
 * @visibleName Grid
 */

// prefix name with breakpoint?
export default function GridLayout ({ children, extraClass, ...props }) {
  return (
    <div
      {...props}
      className={classnames(extraClass, 'md-grid-layout relative')}
    >
      {children}
    </div>
  )
}

// needs to be used on grid layout
// only suitable for plain backgrounds
// may not be in the right place folder/file-wise
export function GridShapeOverlay ({
  extraClass,
  position = 'top-left',
  ...props
}) {
  return (
    extraClass && (
      <div
        {...props}
        className={classnames(
          extraClass,
          `md-grid-layout__shape-overlay--${position}`,
          'md-grid-layout__shape-overlay display-none md-display'
        )}
      />
    )
  )
}

GridLayout.propTypes = {
  extraClass: PropTypes.string
}

GridShapeOverlay.propTypes = {
  position: PropTypes.oneOf([
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right'
  ]).isRequired
}
